module.exports = __webpack_public_path__ + "static/media/shareholder-icon.e7b8b1b5.svg";